import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchFinSobSidePanelSettings } from '../../../services/finSobSidePanel/fetchFinSobSidePanelSettings'
import { REQUEST_COMPLETENESS_STATUS_FOR_FIN_SOB_SIDE_PANEL_ITEM } from '../constants'

interface IRequestCompletenessStatusForFinSobSidePanelItem {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  category: string
}

export const requestCompletenessStatusForFinSobSidePanelItem = createAsyncThunk(
  REQUEST_COMPLETENESS_STATUS_FOR_FIN_SOB_SIDE_PANEL_ITEM,
  async ({ fYear, partnerId, programType }: IRequestCompletenessStatusForFinSobSidePanelItem) => {
    return fetchFinSobSidePanelSettings({ fYear, partnerId, programType })
  }
)
